import type { FC } from "react"
import "./styles.css"

interface RunIconProps {
  className?: string
  fill?: string
  width?: string | number
  height?: string | number
  "aria-label"?: string
  role?: string
}

export const RunIcon: FC<RunIconProps> = ({ className, fill, width, height, "aria-label": ariaLabel, role }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width || "18"}
    height={height || "18"}
    viewBox="-1 0 18 18"
    fill={fill ? fill : "#BAFD4F"}
    aria-label={ariaLabel}
    role={role}
  >
    <path d="M14.5903 7.21L11.5103 8.77C11.1703 8.94 10.7503 8.85 10.5203 8.56L9.19031 6.91L8.38031 9.5L10.9103 11.09C11.1203 11.22 11.2603 11.45 11.2803 11.7C11.3003 11.95 11.2103 12.2 11.0203 12.37L8.01031 15.15C7.68031 15.45 7.17031 15.43 6.87031 15.11C6.57031 14.78 6.59031 14.27 6.91031 13.97L9.14031 11.9L6.64031 10.33L5.48031 13.85C5.44031 13.97 5.37031 14.08 5.29031 14.16L1.95031 17.54C1.79031 17.7 1.58031 17.78 1.38031 17.78C1.18031 17.78 0.970312 17.7 0.810312 17.55C0.490313 17.24 0.490313 16.73 0.810312 16.41L4.02031 13.17L5.16031 9.74H5.15031L6.36031 5.68H4.94031V8.32C4.94031 8.77 4.58031 9.13 4.13031 9.13C3.68031 9.13 3.32031 8.77 3.32031 8.32V4.87C3.32031 4.42 3.68031 4.06 4.13031 4.06H8.58031C8.82031 4.06 9.06031 4.17 9.21031 4.36L11.3603 7.04L13.8603 5.78C14.2603 5.58 14.7403 5.74 14.9403 6.14C15.1403 6.54 14.9803 7.02 14.5803 7.22L14.5903 7.21Z" />
    <path d="M9.89969 3.67999C10.7115 3.67999 11.3697 3.02185 11.3697 2.20999C11.3697 1.39813 10.7115 0.73999 9.89969 0.73999C9.08783 0.73999 8.42969 1.39813 8.42969 2.20999C8.42969 3.02185 9.08783 3.67999 9.89969 3.67999Z" />
  </svg>
)
